import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSnackbar } from "notistack";
import TabHeaderComponent from "../../../Components/Navigations/SimpleTabHeaderComponent";
import TabPanelComponent from "../../../Components/Navigations/SimpleTabPanelComponent";
import ConeLogisticoConfiguracaoFundoTab from "../ConeLogistico/ConeLogisticoConfiguracaoFundoTab";
import ConeLogisticoConfiguracaoCentralTab from "../ConeLogistico/ConeLogisticoConfiguracaoCentralTab";
import PopupBasePage from "../../../Components/Base/BasePopup";
import { ConeLogisticoConfiguracao } from "../../../Models/Paineis/ConeLogistico/ConeLogisticoConfiguracao";
import { FileUploadService } from "../../../Services/Bases/FileUploadService";
import ConeLogisticoConfiguracaoGraficoDireitaTab from "./ConeLogisticoConfiguracaoGraficoDireitaTab";

const ConeLogisticoConfiguracaoPopup = (props: any) => {
    const [tabValue, setTabValue] = React.useState(0);
    const [coneLogisticoConfiguracao, setConeConfiguracao] = useState<any>(new ConeLogisticoConfiguracao());
    const [coneConfiguracaoInicial, setConeConfiguracaoInicial] = useState<any>(new ConeLogisticoConfiguracao());
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        (async () => {
            await loadStyleCone();
        })();
    }, []);
    
    useEffect(() => {
        setDefaultConeConfiguracao();
        setTimeout(setColorConeConfiguracao, 1000);
    }, [coneLogisticoConfiguracao]);

    async function loadStyleCone() {
        let response: any = await axios.get(`coneLogisticoConfiguracao`);
        if (response.data != null && response.data != "") {
            setConeConfiguracao(response.data);
        }
    }
    
    function setColorConeConfiguracao()
    {
        for (const [key, value] of Object.entries(coneLogisticoConfiguracao)) {
            if (value == '' || value == null)
            {
                continue;
            }
            
            let colorClass = `area_${key}`;
            let elements = document.getElementsByClassName(colorClass) as HTMLCollectionOf<HTMLElement>;
            if (elements.length == 0)
            {
                elements = document.getElementsByClassName(key) as HTMLCollectionOf<HTMLElement>;
                if (elements.length > 0) {
                    for (let index = 0; index < elements.length; index++) {
                        elements[index].innerHTML = `${value}`;
                    }
                }

                continue;
            }

            Array.prototype.forEach.call(elements,
                function(element: any) {
                    setColor(key, element, value);
                }
            );
        }
    }

    function setColor(key: string, element: any, value: {}) {
        if (key == 'cor_fonte_titulo') {
            element.style['color'] = value;
        }
        else if (key == 'cor_fundo') {
            element.style['background-color'] = value;
        }

        else {
            element.style['fill'] = value;
        }
    }

    function setDefaultConeConfiguracao()
    {
        for (const [key, value] of Object.entries(coneConfiguracaoInicial)) {
            let colorClass = `area_${key}`;
            
            let elements = document.getElementsByClassName(colorClass) as HTMLCollectionOf<HTMLElement>;
            if (elements.length == 0)
            {
                coneConfiguracaoInicial[key] = '';
                continue;
            }

            Array.prototype.forEach.call(elements,
                function(element: any) {
                    if (key == 'cor_fonte_titulo') {
                        coneConfiguracaoInicial[key] = element.style['color'];
                    }
                    else if (key == 'cor_fundo') {
                        coneConfiguracaoInicial[key] = element.style['background-color'];
                    }
                    else {
                        coneConfiguracaoInicial[key] = element.style['fill'];
                    }

                    return;
            });
        }
    }

    function colorChangedCallback(field: string, type: string)
    {
        let colorClass = `area_${field}`;

        let elements = document.querySelectorAll(`#formConeConfiguracoes .${colorClass}`);
        if (elements.length == 0)
        {
            return;
        }

        let valueInicial = coneConfiguracaoInicial[field];
        let valueNovo = coneLogisticoConfiguracao[field];
        Array.prototype.forEach.call(elements,
            function(element: any) {
            //console.log(valueNovo + ' - ' + valueInicial);
            if (valueNovo == null || valueNovo == "")
            {
                setColor(field, element, valueInicial);
            }
            else {
                setColor(field, element, valueNovo);
            }  
        });
    }

    
    function textFieldChangedCallback(field: string, text: string) {
        console.log(field)
        console.log(text)
        let elements = document.querySelectorAll(`#formConeConfiguracoes .${field}`);
        if (elements.length == 0)
        {
            return;
        }

        elements[0].innerHTML = text;
    }

    async function saveAsync() {
        try {
            const imageUploaded = await (new FileUploadService()).uploadImageAsync(coneLogisticoConfiguracao, 'logotipo');
            if (!imageUploaded){
                enqueueSnackbar('Erro ao salvar imagem!', { variant: 'error' });
                return;
            }

            if (coneLogisticoConfiguracao?.id == null || coneLogisticoConfiguracao?.id == 0 || coneLogisticoConfiguracao?.id == '') {
                await axios.post('coneLogisticoConfiguracoes', coneLogisticoConfiguracao);
            }
            else {
                await axios.put(`coneLogisticoConfiguracoes/${coneLogisticoConfiguracao.id}`, coneLogisticoConfiguracao);
            }

            enqueueSnackbar('Salvo com sucesso!', { variant: 'success' });
            let response: any = await axios.get(`coneLogisticoConfiguracao`);
            setConeConfiguracao(response.data);
        } catch (error) {
            enqueueSnackbar('Erro ao salvar!', { variant: 'error' });
        }
        finally {
            document.body.style.cursor = "default";
        }
    }

    return (
        <PopupBasePage title="Cone Logistico Configuração" isOpen={props.isOpen} onClose={props.onClose} onClickFirstButtonPopupCallback={saveAsync} isPesquisa='false' confirmClose={true}>
            <div className="container">
                <div className="row">
                    <div className="align-all-left col-md-12 order-md-1">
                        <TabHeaderComponent setTabValueEventCallBack={setTabValue} label="Configuração Cone" tabs={['Fundo e Cabeçalho', 'Cone', 'Gráfico Direita',]} tab="cone" />

                        <form className="needs-validation" id="formConeConfiguracoes">
                            <TabPanelComponent value={tabValue} index={0} tab="fundo" tabHeader="cone">
                                <ConeLogisticoConfiguracaoFundoTab coneLogisticoConfiguracao={coneLogisticoConfiguracao} colorChangedCallback={colorChangedCallback}  />
                            </TabPanelComponent>

                            <TabPanelComponent value={tabValue} index={1} tab="central" tabHeader="cone" disableMargin={true}>
                                <ConeLogisticoConfiguracaoCentralTab
                                    coneLogisticoConfiguracao={coneLogisticoConfiguracao}
                                    colorChangedCallback={colorChangedCallback}
                                    textFieldChangedCallback={textFieldChangedCallback} />
                            </TabPanelComponent>

                            <TabPanelComponent value={tabValue} index={2} tab="grafico" tabHeader="cone">
                                <ConeLogisticoConfiguracaoGraficoDireitaTab coneLogisticoConfiguracao={coneLogisticoConfiguracao} colorChangedCallback={colorChangedCallback} />
                            </TabPanelComponent>
                        </form>
                    </div>
                </div>
            </div >
        </PopupBasePage>
    );
}

export default ConeLogisticoConfiguracaoPopup;